import PropTypes from 'prop-types';
import React from 'react';

import config from '../../config';
import { translate as t } from '../../lib/I18n';
import { minutesAsDaysOrMinutes } from '../../helpers/Durations';

import Icon from '../general/Icon';
import BaseModal from '../general/BaseModal';

function LoggedOutModal ({ onClose }) {
    const modalProps = {
        disableBlur: true,
        disableEscape: true,
        titleText: 'account.loggedOut',
        onClose,
        hideContinue: true,
        className: "modal--sm auto-logout-modal",
        backdropClassName: "auto-logout-modal",
    };

    return (
        <BaseModal { ...modalProps }>
            <div className="vertical-align-parent full-height">
                <div className="confirmation vertical-align text-center">
                    <Icon icon="clock" className="margin-bottom--sm otrl-xl" />

                    <p className="alert-warning text-weight--normal">
                        { t('account.loggedOut.youWereloggedOut') }
                    </p>

                    <p className="text-center">
                        { t('account.loggedOut.possibleReasons', {
                            autoLogoutMinutes: config.get('autoLogoutMinutes'),
                            duration: minutesAsDaysOrMinutes(config.get('autoLogoutMinutes'))
                        }) }
                    </p>
                </div>
            </div>
        </BaseModal>
    );
}

LoggedOutModal.propTypes = {
    onClose: PropTypes.func.isRequired
};

export default LoggedOutModal;
